import { render } from "./UploadReports.vue?vue&type=template&id=5f111341"
import script from "./UploadReports.vue?vue&type=script&lang=js"
export * from "./UploadReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__